define('modules/form_editor/views/preview_custom_year',['require','exports','module','./preview_base','../../editor/models/editorstate','ldsh!../templates/preview_custom_range'],function(require, exports, module){
  "use strict";
  var PreviewBase = require("./preview_base");

  /* Sure there is a better way to do this, but it means refactor */
  var EditorState = require("../../editor/models/editorstate");

  module.exports = PreviewBase.extend({
    template: require("ldsh!../templates/preview_custom_range"),
    onRender: function(){
      module.exports.__super__.onRender.apply(this, arguments);
      var start = this.model.get("start"),
          end = this.model.get("end") + 1;

      if(this.model.get("firstOptionInvalid")){
        var $firstOption = $("<option />")
          .attr("value", "")
          .text(this.localize("formEditor.selectYear"));

        this.$("select").append($firstOption);
      }
      while (start < end){
        this.$("select").append("<option value=" + (--end) + ">" + end + "</option>");
       }
    },
  });
});

